import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { IconActionComment } from '../../icons/IconActionComment/IconActionComment'
import { IconComment } from '../../icons/IconComment/IconComment'
import { IconCommentTN } from '../../icons/IconCommentTN/IconComment'
import { TextLink } from '../../typography/TextLink/TextLink'
import { colors } from '../../__styling/settings/colors'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledCommentsWrapper = styled('div')(({ theme }) => [
    {
        minHeight: calcRem(24),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        color: tokens.thenightly.colors.actions.link.default,
        fontFamily: theme.fonts.sansSerif,
        fontSize: calcRem(16),
        fontWeight: 700,
        lineHeight: calcRem(24),
        gap: calcRem(4),
    },
])

export const StyledCommentsIcon = styled(IconCommentTN)({
    width: calcRem(18),
    height: calcRem(18),
    fill: colors.thenightly.neutral[100],
    strokeWidth: 0,
})

export const StyledIconWrapper = styled('div')({
    width: calcRem(24),
    height: calcRem(24),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: calcRem(4),
})

export const StyledTextLink = styled(TextLink)(({ theme }) => [
    {
        fontFamily: theme.fonts.sansSerif,
        fontSize: calcRem(16),
        fontWeight: 600,
        lineHeight: calcRem(24),
        color: colors.thenightly.neutral[100],
        textDecoration: 'none',
        textTransform: 'uppercase',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        ':hover': {
            background: 'none',
            color: colors.thenightly.neutral[100],
        },
    },
])
